import { Fancyapps } from "@Libraries/Fancyapps";
import type { UnobtrusiveValidation } from "@Validation/UnobtrusiveValidation";
import Imask from "imask/holder";
import "imask/masked/date"
import { Fancybox } from "typings/Fancyapps";

export class BackgroundCheck
{
	public Form: HTMLFormElement;
	public Validation: UnobtrusiveValidation;

	constructor(validation: UnobtrusiveValidation, form: HTMLFormElement)
	{
		this.Validation = validation;
		this.Form = form;
		this.ConfigurePrizeCalendar()
		this.ConfigureAcceptTerms();
		this.ConfigureBirthDateMask();
	}

	public ConfigureAcceptTerms = (): void =>
	{
		const acceptEmploymentTermsNo = document.getElementById("AcceptEmploymentTermsNo") as HTMLInputElement;

		document.querySelectorAll("input[name='AcceptEmploymentTerms']")?.forEach(input =>
		{
			input.addEventListener("change", (e) =>
			{
				this.Validation.Service.isFieldValid(acceptEmploymentTermsNo);

				if (!acceptEmploymentTermsNo.checked)
				{
					this.Validation.ResetValidation(this.Form);
				}
			});
		});
	}

	public ConfigureBirthDateMask = (): void =>
	{
		const birthDateInput = document.getElementById("BirthDate") as HTMLInputElement;

		if (birthDateInput)
		{
			// Default Mask Options
			const defaultMaskOptions = {
				mask: Date,
				pattern: 'mm/dd/YYYY',
				blocks: {
					mm: {
						mask: Imask.MaskedRange,
						from: 1,
						to: 12,
						maxLength: 2,
					},
					dd: {
						mask: Imask.MaskedRange,
						from: 1,
						to: 31,
						maxLength: 2,
					},
					YYYY: {
						mask: Imask.MaskedRange,
						from: 1900,
						to: new Date().getFullYear(),
					}
				},

				// define date -> str convertion
				format: function (date)
				{
					let month = (date.getMonth() + 1).toString();
					let day = date.getDate().toString();
					let year = date.getFullYear().toString();

					if (parseInt(month) < 10) month = "0" + month;
					if (parseInt(day) < 10) day = "0" + day;

					return [month, day, year].join('/');
				},

				// define str -> date convertion
				parse: function (str)
				{
					// string is in format mm/dd/yyyy
					let dateArray = str.split('/');
					let month = parseInt(dateArray[0]) - 1;
					let day = parseInt(dateArray[1]);
					let year = parseInt(dateArray[2]);

					// date constructors in js are year, month, day
					return new Date(year, month, day);
				},

				// also Pattern options can be set
				lazy: true,

				// and other common options
				overwrite: true  // defaults to `false`
			};

			new Imask.InputMask(birthDateInput, defaultMaskOptions)
		}
	}

	public ConfigurePrizeCalendar = async () =>
	{
		const prizeCalendarLink = document.getElementById("PrizeCalendarLink") as HTMLAnchorElement;
		const fancyapps = await Fancyapps.Import();
	}
}